import * as enums from './Enums';
import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';
export interface IOrganizationListingModel extends IModel {
  code: string;
  description: string;
  name: string;
  organizationId: number;
  organizationSource: string;
  organizationSourceId: number;
  organizationType: string;
  organizationTypeId: enums.OrganizationTypes;
  organizationVersion: string;
  organizationVersionId: number;
  shortName: string;
}

export class OrganizationListingModel
  extends Model
  implements ModelRecord<IOrganizationListingModel>
{
  code: string;
  description: string;
  name: string;
  organizationId: number;
  organizationSource: string;
  organizationSourceId: number;
  organizationType: string;
  organizationTypeId: any;
  organizationVersion: string;
  organizationVersionId: number;
  shortName: string;

  constructor(params?: Partial<IOrganizationListingModel>) {
    super(params);
    this.code = defaultTo(params?.code, '');
    this.description = defaultTo(params?.description, '');
    this.name = defaultTo(params?.name, '');
    this.organizationId = defaultTo(params?.organizationId, 0);
    this.organizationSource = defaultTo(params?.organizationSource, '');
    this.organizationSourceId = defaultTo(params?.organizationSourceId, 0);
    this.organizationType = defaultTo(params?.organizationType, '');
    this.organizationTypeId = defaultTo(params?.organizationTypeId, 0);
    this.organizationVersion = defaultTo(params?.organizationVersion, '');
    this.organizationVersionId = defaultTo(params?.organizationVersionId, 0);
    this.shortName = defaultTo(params?.shortName, '');
  }
}
